export default __webpack_public_path__ + "static/media/SKY.e9c15b63.svg";